<div (click)="onClick()" class="d-flex justify-content-between p-3">
  <div class="left-side">
    <div class="truncate-ellipsis" [mdbTooltip]="model.title" placement="bottom" (click)="onClick()">
      <app-title [title]="model.title"></app-title>
    </div>
    <div class="truncate-ellipsis" [mdbTooltip]="model.description" placement="bottom" (click)="onClick()">
      <span>{{model.description}}</span>
    </div>
  </div>
  <div *ngIf="!isHandled()" class="right-side">
    <div class="text-right font-size-08 text-truncate">
      <i class="fa fa-calendar mr-1 fa-lg color"></i>
      {{model.observedOn | date: applicationConfig.DATE_FORMAT}}
    </div>
    <div class="text-right mt-1 text-truncate">
      <span>{{Localization.By | translate | lowercase}}</span>
      <span>&nbsp;</span>
      <span class="font-weight-400 font-size-08">{{model.observerFirstName}} {{model.observerLastName}}</span>
    </div>
  </div>
  <div *ngIf="isHandled()" class="d-flex justify-content-end align-items-center">
    <span class="text-success font-weight-400 text-uppercase" [translate]="'issueNotificationStatus_Handled'"></span>
  </div>
</div>


